<template>
  <v-card>
    <v-dialog
      v-model="dialog"
      persistent
      scrollable
      max-width="700"
      :fullscreen="$vuetify.breakpoint.xsOnly"
    >
      <v-card>
        <v-toolbar max-height="64">
          <v-toolbar-title>
            {{ $t("document") }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text style="height: auto" class="pa-2">
          <div v-if="document">
            <v-textarea
              v-if="language === 'pt'"
              v-html="document.texto_pt"
              readonly
            />
            <v-textarea
              v-if="language === 'en'"
              v-html="document.texto_en"
              readonly
            />
            <v-textarea
              v-if="language === 'es'"
              v-html="document.texto_es"
              readonly
            />
          </div>
        </v-card-text>
        <v-divider></v-divider>
      </v-card>
    </v-dialog>
    <v-container class="d-flex justify-center">
      <v-select
        v-model="select"
        :items="items"
        item-text="text"
        item-value="value"
        :label="$t('type')"
        dense
        filled
        hide-details
        solo-inverted
        return-object
      ></v-select>
      <v-btn class="primary ml-4 align-self-center" @click="fetchDocument">
        {{ $t("search") }}
      </v-btn>
    </v-container>
    <v-card-text>
      <v-container v-if="fetching" fill-height fluid>
        <v-row align="center" justify="center">
          <v-col class="d-flex align-center justify-center">
            <v-progress-circular
              indeterminate
              color="info"
            ></v-progress-circular>
          </v-col>
        </v-row>
      </v-container>
      <div v-if="!fetching">
        <v-data-table
          :headers="headers"
          :items="documents"
          :items-per-page="10"
          :footer-props="{
            'items-per-page-text': this.$t('rowsPerPage'),
          }"
        >
          <template v-slot:item.id="{ item }">
            <v-btn x-small @click="$copy(item.id)">
              {{ item.id }}
            </v-btn>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn small @click="openDialog(item.id)">
              <v-icon>mdi-eye</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </div>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  data: (_this) => ({
    dialog: false,
    search: "",
    document: {},
    documents: [],
    fetching: false,
    headers: [
      {
        text: "ID",
        value: "id",
      },
      {
        text: "Data",
        value: "data_cadastro",
      },
      {
        text: _this.$t("actions"),
        value: "actions",
      },
    ],
    select: {
      text: _this.$t("termsOfUse"),
      value: "termos_de_uso",
    },
    items: [
      {
        text: _this.$t("termsOfUse"),
        value: "termos_de_uso",
      },
      {
        text: _this.$t("responsibleGambling"),
        value: "jogo_responsavel",
      },
      {
        text: _this.$t("dataProtection"),
        value: "protecao_de_dados",
      },
      {
        text: _this.$t("aml"),
        value: "aml",
      },
    ],
  }),
  created() {
    this.fetchDocument();
  },
  computed: {
    language() {
      return localStorage.getItem("language");
    },
  },
  methods: {
    fetchDocument() {
      this.fetching = true;

      if (this.document) {
        this.document = null;
      }

      const endpoint = "/colab/operator/listDocuments";
      const body = { type: this.select.value };

      this.$request
        .post(endpoint, body)
        .then((res) => {
          this.documents = res.dados.map((document) => {
            document.data_cadastro = new Date(
              document.data_cadastro.replace(" ", "T")
            ).toLocaleString();

            return document;
          });
        })
        .catch(() => {
          this.documents = [];
        })
        .finally(() => {
          this.fetching = false;
        });
    },
    openDialog(id) {
      this.dialog = true;
      this.document = this.documents.find((document) => document.id === id);
    },
    closeDialog() {
      this.dialog = false;
      this.document = {};
    },
  },
};
</script>
